gsap.registerPlugin(ScrollTrigger)

var a, s,
SLM = {
  
  elements: {
    header: document.querySelector('.site-header'),
    loader: document.querySelector('.site-loader'),
    menuItems: document.querySelectorAll('.site-header__menu-item-link, .site-header__mobile-menu-item-link, .site-header__title'),
    mobNavBtn: document.querySelector('.site-header__mob-nav-btn'),
    mobNav: document.querySelector('.site-header__mobile-menu'),
    mobNavStuff: document.querySelectorAll('.site-header__mobile-menu-item, .site-header__mobile-menu-sec-list'),
  },

  settings: {
    mobMenuOpen: false,
    mobMenuTl: gsap.timeline(),
  },

  init: function() {
    a = this.elements;
    s = this.settings;
    this.loader();
    this.onevh();
    this.swup();
    this.menu();
    this.header();
    this.footer();
    this.popup();
    
    this.hero();
    this.ticker();
    this.testimonials();
    this.gallery();
    this.accordions();
    this.product();
    this.videoLoaders();
    fitVids('.site-content');
  },

  videoLoaders: function(){
    const videos = document.querySelectorAll('.image-button-section__video, .hero-section__video');

    if (videos.length) {
      videos.forEach((v) => {
        v.addEventListener('loadeddata', (e) => {
          setTimeout(() => {
            v.classList.add('loaded');
          }, 1000);
        });

        v.addEventListener('canplay', (e) => {
          setTimeout(() => {
            v.classList.add('loaded');
          }, 1000);
        });

        const loader = v.parentNode.querySelector('.loader');
        var timeleft = 0;
        var ascendingTimer = setInterval(function(){
          timeleft++;
          loader.textContent = timeleft + '%';
          if (timeleft==100) {
            clearInterval(ascendingTimer);
          }
        },101);
      })
    }
  },
  
  onevh: function(){
    const set1vh = () => {
      const vh = document.documentElement.clientHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    set1vh();

    window.addEventListener('resize', set1vh);
  },
  
  menu: function(){
  
    a.mobNavBtn.addEventListener('click', function() {
      SLM.toggleMenu();
    });

    a.menuItems.forEach(menuItem => {
      menuItem.addEventListener('click', e => {
        if (s.mobMenuOpen) {
          SLM.toggleMenu();
        }

        a.menuItems.forEach(menuItemm => {
          if (menuItemm.classList.contains('site-header__mobile-menu-item-link')) {
              menuItemm.classList.remove('site-header__mobile-menu-item-link--active')
          } else if (menuItemm.classList.contains('site-header__menu-item-link')) {
              menuItemm.classList.remove('site-header__menu-item-link--active')
          }
        });

        if (menuItem.classList.contains('site-header__mobile-menu-item-link')) {
            menuItem.classList.add('site-header__mobile-menu-item-link--active')
        } else if (menuItem.classList.contains('site-header__menu-item-link')) {
            menuItem.classList.add('site-header__menu-item-link--active')
        }
      });
    });
  
  },

  menuActives: function(){

    a.menuItems.forEach(menuItem => {
        if (window.location.href.includes(menuItem.href)) {
            if (menuItem.classList.contains('site-header__mobile-menu-item-link')) {
                menuItem.classList.add('site-header__mobile-menu-item-link--active')
            } else if (menuItem.classList.contains('site-header__menu-item-link')) {
                menuItem.classList.add('site-header__menu-item-link--active')
            }
        } else {
            if (menuItem.classList.contains('site-header__mobile-menu-item-link')) {
                menuItem.classList.remove('site-header__mobile-menu-item-link--active')
            } else if (menuItem.classList.contains('site-header__menu-item-link')) {
                menuItem.classList.remove('site-header__menu-item-link--active')
            }
        }
    });
  
  },

  popup: function() {

    const popupSection = document.querySelector('.popup-section');
    const popupCookie = Cookies.get('slm-popup');
    if (popupSection && !popupCookie) {
      const popupSectionInner = popupSection.querySelector('.popup-section__wrap');
      const popupSectionClose = document.querySelector('.popup-section__close');
      const popupSectionLink = document.querySelector('.popup-section__link');

      setTimeout(() => {
        gsap.to(popupSection, { duration: 0.5, autoAlpha: 1 });
        document.body.classList.add('overflow-hidden');
      }, 5000);

      popupSectionClose.addEventListener('click', () => {
        gsap.to(popupSection, { duration: 0.5, autoAlpha: 0 });
        document.body.classList.remove('overflow-hidden');
        Cookies.set('slm-popup', 'true', { expires: 7 });
      });

      popupSection.addEventListener('click', () => {
        gsap.to(popupSection, { duration: 0.5, autoAlpha: 0 });
        document.body.classList.remove('overflow-hidden');
        Cookies.set('slm-popup', 'true', { expires: 7 });
      });

      popupSectionInner.addEventListener('click', (e) => {
        e.stopPropagation();
      });

      if (popupSectionLink) {
        popupSectionLink.addEventListener('click', () => {
          gsap.to(popupSection, { duration: 0.5, autoAlpha: 0 });
          document.body.classList.remove('overflow-hidden');
          Cookies.set('slm-popup', 'true', { expires: 7 });
        });
      }
    }
  },

  gallery: function() {
    const gallerySectionSlidersDesk = document.querySelectorAll('.gallery-section__slider--desk');
    
    if (gallerySectionSlidersDesk.length) {
      gallerySectionSlidersDesk.forEach((gallerySectionSlider, q) => {
        const gallerySectionSliderMob = gallerySectionSlider.nextElementSibling;

        if (gallerySectionSlider.classList.contains('gallery-section__slider--gram')) {
          const url = 'https://graph.instagram.com/me/media/?fields=media_url,permalink,media_type,thumbnail_url&access_token=' + instagramToken + '&amp;count=4';

          fetch(url)
            .then(response => response.json())
            .then(data => {
                if (data) {
                  const gallerySectionSliderWrap = gallerySectionSlider.querySelector('.gallery-section__slider-wrap');

                  let HTML = '';

                  data.data.forEach((gram, i) => {
                    if (i < 6) {
                      if (gram.media_type == 'VIDEO') {
                        HTML += `<li class="gallery-section__slider-item">
                          <figure class="lazy-container" style="padding-bottom: 100%;">
                            <img
                              src="${gram.thumbnail_url}"
                              loading="lazy"
                              class="img-rounded"
                            />
                          </figure>
                        </li>`;
                      } else {
                        HTML += `<li class="gallery-section__slider-item">
                          <figure class="lazy-container" style="padding-bottom: 100%;">
                            <img
                              src="${gram.media_url}"
                              loading="lazy"
                              class="img-rounded"
                            />
                          </figure>
                        </li>`;
                      }
                    }
                  });

                  gallerySectionSliderWrap.innerHTML = HTML;
                  gallerySectionSliderMob.innerHTML = HTML;

                  SLM.gallerySliderDesk(gallerySectionSlider);
                  SLM.gallerySliderMob(gallerySectionSliderMob);
                }
            });
        } else {
          SLM.gallerySliderDesk(gallerySectionSlider);
          SLM.gallerySliderMob(gallerySectionSliderMob);
        }
      });
    }
  },

  gallerySliderDesk: function(gallerySectionSlider) {
    const gallerySectionSliderWrap = gallerySectionSlider.querySelector('.gallery-section__slider-wrap');
    gsap.to(gallerySectionSliderWrap, {
      x: () => (gallerySectionSliderWrap.offsetWidth - gallerySectionSlider.offsetWidth) * -1,
      ease: "power1.in",
      scrollTrigger: {
        trigger: gallerySectionSlider,
        start: "top bottom",
        end: "bottom 50%",
        scrub: 1.5
      }
    });
  },

  gallerySliderMob: function(gallerySectionSlider) {
    var flkty = new Flickity(gallerySectionSlider, {
      autoPlay: false,
      pageDots: false,
      prevNextButtons: false,
      cellAlign: 'left',
      contain: true,
      adaptiveHeight: true
    });
  },
  
  testimonials: function(){
  
    const testimonialSections = document.querySelectorAll('.testimonial-section');
    if (testimonialSections.length) {
      testimonialSections.forEach((testimonialSection, q) => {
        const testimonialSlider = testimonialSection.querySelector('.testimonial-section__items--slider');
        if (testimonialSlider) {
          
          var flkty = new Flickity(testimonialSlider, {
            autoPlay: false,
            pageDots: false,
            draggable: false,
            prevNextButtons: false,
            cellAlign: 'left',
            wrapAround: true,
            contain: true,
            adaptiveHeight: true
          });
          
          const testimonialSliderPrevious = testimonialSection.querySelector('.testimonial-section__nav-btn--previous');
          const testimonialSliderNext = testimonialSection.querySelector('.testimonial-section__nav-btn--next');
          const testimonialSliderCurrent = testimonialSection.querySelector('.testimonial-section__nav-position-current');
          
          flkty.on('change', (index) => {
            testimonialSliderCurrent.textContent = index + 1;
          });
          
          testimonialSliderPrevious.addEventListener('click', () => {
            flkty.previous();
          });
        
          testimonialSliderNext.addEventListener('click', () => {
            flkty.next();
          });
          
        }
    
        const testimonialVideoBtns = testimonialSection.querySelectorAll('.testimonial-section__item-video-btn');
        if (testimonialVideoBtns.length) {
          testimonialVideoBtns.forEach((testimonialVideoBtn) => {
            const modal = testimonialSection.querySelector('#' + testimonialVideoBtn.dataset.id);
            const modalInner = modal.querySelector('.overlay__inner');
            const modalCloseBtn = modal.querySelector('.overlay__close-btn');
            const modalVideo = modal.querySelector('.overlay__video');

            testimonialVideoBtn.addEventListener('click', () => {
              modal.setAttribute('open', '');
              document.body.classList.add('overflow-hidden');
              modalVideo.play(); 
            });

            modal.addEventListener('click', () => {
              modal.removeAttribute('open');
              document.body.classList.remove('overflow-hidden');
              modalVideo.pause();
            });
    
            modalCloseBtn.addEventListener('click', () => {
              modal.removeAttribute('open');
              document.body.classList.remove('overflow-hidden');
              modalVideo.pause();
            });

            modalInner.addEventListener('click', (e) => {
              e.stopPropagation();
            });
          });
        }
    
      });
    }
    
  },
  
  toggleMenu: function(){
	  
    s.mobMenuOpen = !s.mobMenuOpen;

    if (s.mobMenuOpen) {
      document.body.classList.add('overflow-hidden');
      s.mobMenuTl
      .to(a.mobNav, .325, { autoAlpha: 1, ease: 'Expo.inOut', onStart: () => a.mobNavBtn.classList.add('site-header__mob-nav-btn--active') }, '-=.25')
      .staggerFromTo(a.mobNavStuff, .325, { opacity: 0, x: '-1rem' }, { opacity: 1, x: 0 }, 0.2, '-=.325')
    } else {
      document.body.classList.remove('overflow-hidden');
      s.mobMenuTl
      .to(a.mobNav, .325, { autoAlpha: 0, ease: 'Expo.inOut', onComplete: () => a.mobNavBtn.classList.remove('site-header__mob-nav-btn--active') })
    }

  },

  swup: function(){

    var swup = new Swup({
      containers: [".site-content"],
      plugins: [
        new SwupScrollPlugin({
			doScrollingRightAway: true,
			animateScroll: false,
		}),
        new SwupBodyClassPlugin(),
        new SwupScriptsPlugin({ head: false, body: true })
      ]
    });

    swup.on('contentReplaced', function(e) {
      SLM.hero();
      SLM.ticker();
      SLM.testimonials();
      SLM.gallery();
      SLM.accordions();
      SLM.menuActives();
      SLM.product();
      SLM.videoLoaders();
      
      fitVids('.site-content');
      ScrollTrigger.refresh();
      ScrollTrigger.sort();

      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize()
      }

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init()
      }

      if (window.ReChargeWidget) {
        initRecharge();
      }
    })

  },

  header: function(){

    const options = {
      offset: {
        up: 100,
        down: 50
      }
    }

    const headroom  = new Headroom(a.header, options);
    headroom.init();

  },

  scroll: function(){

    ScrollTrigger.batch("[data-scroll]", {
      onEnter: (elements, triggers) => {
        gsap.to(elements, {opacity: 1, stagger: 0.15});
      },
      /*onLeave: (elements, triggers) => {
        gsap.to(elements, {opacity: 0, stagger: 0.15});
        console.log(elements.length, "elements left");
      }*/
    });

  },

  accordions: function() {
    const accordionRows = document.querySelectorAll('.accordion-section__row');
    if (accordionRows.length) {
      accordionRows.forEach((accordionRow, q) => {
        const accordionRowBtn = accordionRow.querySelector('.accordion-section__row-button');
        const accordionRowCopy = accordionRow.querySelector('.accordion-section__row-copy');

        let accordionOpen = false;

        accordionRowBtn.addEventListener('click', () => {
          accordionOpen = !accordionOpen;
          if (accordionOpen) {
            accordionRow.setAttribute('aria-expanded', 'true');
            gsap.to(accordionRowCopy, { duration: 0.3125, height: 'auto', autoAlpha: 1, onComplete: () => ScrollTrigger.refresh() });
          } else {
            accordionRow.setAttribute('aria-expanded', 'false');
            gsap.to(accordionRowCopy, { duration: 0.3125, height: 0, autoAlpha: 0, onComplete: () => ScrollTrigger.refresh() });
          }
        });
      });
    }
  },

  loader: function(){

    if (a.loader) {

      const tl = gsap.timeline();

      tl.to(a.loader, { autoAlpha: 0, duration: .5, delay: .5,  ease: 'power2.inout' });

    }

  },
  
  hero: function(){
    const heroTextContainers = document.querySelectorAll('.hero-section__texts');
    if (heroTextContainers.length) {
      heroTextContainers.forEach((heroTextContainer, q) => {
        const heroTexts = heroTextContainer.querySelectorAll('.hero-section__text');
        
        heroTexts.forEach((heroText, i) => {
          let x = 30 + (i * 1.5) + '%';
          if (i % 2) {
            x = -30 - (i * 1.5) + '%';
          }

          gsap.to(heroText, {
            x: x,
            ease: "power1.in",
            scrollTrigger: {
              trigger: heroTextContainer,
              start: "top bottom",
              end: "bottom top",
              scrub: 1.5
            }
          });
        });
      });
    }
  },

  footer: function(){
    const newsletterTexts = document.querySelectorAll('.site-footer__newsletter-text-text');
    if (newsletterTexts.length) {
      newsletterTexts.forEach((newsletterText, i) => {
        let x = () => innerWidth * 20 / 100;
        if (i == 1) {
          x = () => innerWidth * 15 / 100 * -1;
        } else if (i == 2) {
          x = () => innerWidth * 25 / 100;
        }

        gsap.to(newsletterText, {
          x: x,
		  ease: "power1.in",
		  scrollTrigger: {
		    trigger: newsletterText,
		    start: "top bottom",
		    end: "bottom top",
		    scrub: 1.5
		  }
		});
      });
    }
  },

  product: function(){

    const productSignUpSections = document.querySelectorAll('.product-sign-up-section');
    if (productSignUpSections.length) {
      productSignUpSections.forEach((productSignUpSection, i) => {
        const productSignUpToggle = productSignUpSection.querySelector('.product-sign-up-section__form-toggle');
        const productSignUpSectionForm = productSignUpSection.querySelector('.product-sign-up-section__form-section');

        let productSignUpSectionFormOpen = false;
        productSignUpToggle.addEventListener('click', () => {
          productSignUpSectionFormOpen = !productSignUpSectionFormOpen;

          if (productSignUpSectionFormOpen) {
            productSignUpSectionForm.scrollIntoView();
            gsap.to(productSignUpSectionForm, { duration: 0.5, height: 'auto', autoAlpha: 1, onComplete: () => ScrollTrigger.refresh() });
          } else {
            gsap.to(productSignUpSectionForm, { duration: 0.5, height: 0, autoAlpha: 0, onComplete: () => ScrollTrigger.refresh() });
          }
        });

        const productSignUpErrors = productSignUpSection.querySelector('.product-sign-up-section__form-section-error');
        const productSignUpSubmitCheckout = productSignUpSection.querySelector('.product-sign-up-section__form-section-form-submit--checkout');
        
        const fields = productSignUpSection.querySelectorAll('.product-sign-up-section__form-section-form-field');

        if (productSignUpSubmitCheckout) {
          productSignUpSubmitCheckout.addEventListener('click', e => {

             const hasInvalidField = [...fields].some(
              field => !field.checkValidity()
            );
  
            if (
              hasInvalidField
            ) {
              gsap.to(productSignUpErrors, { duration: 0.5, height: 'auto', autoAlpha: 1 });
              productSignUpSectionForm.scrollIntoView();
            } else {
              productSignUpSubmitCheckout.classList.add('product-sign-up-section__form-section-form-submit--disabled');
  
              const productSignUpRealSubmit = productSignUpSection.querySelector('.product-sign-up-section__form-section-form-row--submit .shopify-payment-button__button');
              productSignUpRealSubmit.click();
            }
  
          });
        }

        const productSignUpSubmitEmail = productSignUpSection.querySelector('.product-sign-up-section__form-section-form-submit--email');

        if (productSignUpSubmitEmail) {
          productSignUpSubmitEmail.addEventListener('click', e => {
            if (
              !productSignUpFirstName.validity.valid ||
              !productSignUpLastName.validity.valid ||
              !productSignUpEmail.validity.valid ||
              !productSignUpTerms.validity.valid ||
              !productSignUpPhone.validity.valid ||
              !productSignUpGoals.validity.valid ||
              !productSignUpTraining.validity.valid ||
              !productSignUpHealth.validity.valid ||
              !productSignUpEquipment.validity.valid ||
              !productSignUpStrength.validity.valid ||
              !productSignUpWeakness.validity.valid
            ) {
              gsap.to(productSignUpErrors, { duration: 0.5, height: 'auto', autoAlpha: 1 });
              productSignUpSectionForm.scrollIntoView();
            } else {
  
              // Send email
              const formattedBody = `First Name - ${productSignUpFirstName.value}\r\nLast Name - ${productSignUpLastName.value}\r\nEmail - ${productSignUpEmail.value}\r\nPhone - ${productSignUpPhone.value}\r\nGoals - ${productSignUpGoals.value}\r\nTraining History - ${productSignUpTraining.value}\r\nInjures / Health Concerns - ${productSignUpHealth.value}\r\nEquipment - ${productSignUpEquipment.value}\r\nStrength - ${productSignUpStrength.value}\r\nWeakness - ${productSignUpWeakness.value}\r\nTerms - ${productSignUpTerms.value}`
              location.href = `mailto:${productSignUpSubmitEmail.dataset.mail}?subject=SLM ${productSignUpSubmitEmail.dataset.program} program enquiry from ${productSignUpFirstName.value} ${productSignUpLastName.value}&body=${encodeURIComponent(formattedBody)}`
            }
          });
        }
      });
      
    }
    
  },
  
  ticker: function(){
  
    const tickerElements = document.querySelectorAll('.ticker-section__element');
    
    if (tickerElements.length) {
      
      const tickerElementsImages = document.querySelectorAll('.ticker-section__image');
      
      tickerElements.forEach((tickerElement) => {
      
        let tickerElementHover = tickerElement.querySelector('.ticker-section__element-link');
        
        if (!tickerElementHover) {
          tickerElementHover = tickerElement.querySelector('.ticker-section__element-text');
        }
        
        tickerElementHover.addEventListener('mouseover', () => {
          const tickerElementHoverImage = tickerElementsImages[tickerElement.dataset.key];
          tickerElementHoverImage.classList.add('ticker-section__image--active');
          tickerElement.parentNode.parentNode.classList.add('ticker-section--active');
        });
      
        tickerElementHover.addEventListener('mouseout', () => {
          tickerElementsImages.forEach((tickerElementsImage) => {
            tickerElementsImage.classList.remove('ticker-section__image--active');
            tickerElement.parentNode.parentNode.classList.remove('ticker-section--active');
          });
        });
        
      });
    }
  }

};

(function() {
	SLM.init();
})();